import { render, staticRenderFns } from "./SuppliersGroupsRetrieveUpdate.vue?vue&type=template&id=4f9ac022&"
import script from "./SuppliersGroupsRetrieveUpdate.vue?vue&type=script&lang=js&"
export * from "./SuppliersGroupsRetrieveUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports